exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".layout-breadcrumbs[data-v-7699bf6d]{padding-top:15px;-ms-flex:1 0 auto;flex:1 0 auto;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.layout-breadcrumbs .bread-crumbs[data-v-7699bf6d]{padding-bottom:15px}.layout-breadcrumbs.bg_white[data-v-7699bf6d]{background-color:#fff}.layout-breadcrumbs.bg_grey[data-v-7699bf6d]{background-color:#ededed}.flex[data-v-7699bf6d]{-ms-flex:1 0 auto;flex:1 0 auto;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7699bf6d","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/layout/Breadcrumbs.vue
// module id = 52ddd4d450adc61a6dc1
// module chunks = 0